export const TEST_ID = 'createAssetForm';

export enum ASSET_TYPE {
    DRONE = 'drone',
    BATTERY = 'battery'
}
